import { GetServerSideProps } from "next";
import Head from "next/head";
import { whoAmI } from "@/lib/utils/user";
import { RESOURCES_BASE_API } from "@/lib/utils/constants";
import TermsAndConditionsGold from "components/Legal/TermsAndConditionsGold";
import Header from "@/components/V2/Navigation/Header";
import { useRouter } from "next/router";

type PrivacyPropsType = {
	isLoggedIn: boolean;
	error: boolean;
};

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
	const props: PrivacyPropsType = {
		isLoggedIn: false,
		error: false,
	};

	try {
		const cookie = ctx?.req?.headers?.cookie;
		if (!cookie) {
			return { props };
		}
		const resp = await whoAmI({ cookie });
		props.isLoggedIn = resp && !resp.pin_required ? true : false;
	} catch (error: any) {
		return {
			props,
		};
	}
	return { props };
};

export default function Privacy({ isLoggedIn }: PrivacyPropsType) {
	const router = useRouter();
	return (
		<div className="page_container pt-7">
			<Head>
				<title>Privacy Policy - SALT</title>
				<meta name="description" content="SALT" />
				<link
					rel="icon"
					href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
				/>
			</Head>

			{isLoggedIn && (
				<Header theme="dark" collapseOnScroll defaultBackUrl="/gold" />
			)}
			<TermsAndConditionsGold />
		</div>
	);
}
